import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	selectedBranchId: '',
	selectedRestaurantId: null,
};

const branchSlice = createSlice({
	name: 'branch',
	initialState,
	reducers: {
		setSelectedBranch: (state, action) => {
			state.selectedBranchId = action.payload || '';
		},
		setSelectedRestaurantId: (state, action) => {
			state.selectedRestaurantId = action.payload || null;
		},
	},
});

export const { setSelectedBranch, setSelectedRestaurantId } = branchSlice.actions;
export default branchSlice.reducer;


